export default "__VITE_ASSET__1dac693b__"